/*
 * Copyright (c) 2023. Haodong JU
 */

import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import hillo from 'hillo'
import GlobalSettings from '@/model/global/GlobalSettings'
import StringEntity from '@/model/dataLayer/api/common/StringEntity'

const entity = {
  id: {
    displayName: 'id',
    form: false
  },
  langs: {
    displayName: 'name',
    type: IKDataEntity.Types.Group,
    formConfig: {
      groupName: 'name',
      default: GlobalSettings.supportLang,
      childLabelKey: 'lang',
      type: {}
    },
    tableConfig: {
      displayCondition: (item) => {
        return item.lang.toUpperCase() === GlobalSettings.getLang().toUpperCase()
      },
      displayChild: (key) => {
        return key === 'name'
      }
    },
    childKey: ['name'],
    labelKey: 'lang',
    children: [
      StringEntity, StringEntity, StringEntity
    ]
  },
  printContent: {
    displayName: 'FreeInformationBon'
  },
  sort: {
    type: IKDataEntity.Types.Integer
  },
  operation: {
    displayName: 'operation',
    type: IKDataEntity.Types.String,
    form: false,
    tableConfig: {
      overwrite: true
    }
  }
}

const config = {

  add: function (item) {
    item.icon = ''
    return hillo.post('FreeInformation.php?op=add', {
      ...item,
      langs: JSON.stringify(item.langs)
    })
  },
  remove: function (id) {
    // -9/-10 保留选项
    if (id.toString() === '-9' || id.toString() === '-10') {
      return false
    } else {
      return hillo.post('FreeInformation.php?op=delete', { id })
    }
  },
  edit: function (item) {
    // -9/-10 保留选项
    if (!item.icon) {
      item.icon = ''
    }
    return hillo.postWithUploadFile('FreeInformation.php?op=update', {
      ...item,
      langs: JSON.stringify(item.langs)
    })
  },
  load: async function (filter) {
    return (await hillo.get('FreeInformation.php', filter))
      .content
  }

  // search
}

export default IKDataEntity.ModelFactory(entity, config)
